var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "section",
      { staticClass: "container", attrs: { "data-qa": "core_page_seo" } },
      [
        _vm._l(_vm.textList, function ({ title, description }) {
          return [
            _c(
              title.tag,
              {
                key: title.text,
                tag: "component",
                staticClass: "my-4 text--text text-h6",
              },
              [_vm._v("\n      " + _vm._s(title.text) + "\n    ")]
            ),
            _vm._v(" "),
            _vm._l(description, function (text) {
              return _c(
                "p",
                {
                  key: text,
                  staticClass: "my-4 text-secondary--text text-body-2",
                },
                [_vm._v("\n      " + _vm._s(text) + "\n    ")]
              )
            }),
          ]
        }),
      ],
      2
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }